import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="w-full bg-navy-900 border-t border-white/10 px-4 py-8" data-id="element-25">
        <div className="max-w-4xl mx-auto flex flex-col items-center gap-4" data-id="element-26">
          <div className="flex items-center gap-6" data-id="element-27">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-400 text-sm hover:text-gold transition-colors" data-id="element-28">
              Política de Privacidad
            </button>
            <span className="text-gray-600" data-id="element-29">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-400 text-sm hover:text-gold transition-colors" data-id="element-30">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-gray-500 text-sm" data-id="element-31">
            © 2024 Protocolo SOS: Insomnio Chino. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-32">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-33">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-navy-800 border border-gold/20 rounded-lg w-full max-w-2xl max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-34">
              <div className="sticky top-0 bg-navy-800 border-b border-white/10 px-6 py-4 flex items-center justify-between" data-id="element-35">
                <h3 className="font-serif text-xl text-white" data-id="element-36">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="text-gray-400 hover:text-white transition-colors" data-id="element-37">
                  <XIcon className="w-5 h-5" data-id="element-38" />
                </button>
              </div>

              <div className="px-6 py-6 text-gray-300 text-sm leading-relaxed space-y-4" data-id="element-39">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-40" /> : <TermsContent data-id="element-41" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-gold font-semibold text-base" data-id="element-42">
        Última actualización: Enero 2024
      </p>

      <h4 className="font-serif text-lg text-white mt-4" data-id="element-43">
        1. Información que Recopilamos
      </h4>
      <p data-id="element-44">
        Recopilamos información personal que usted nos proporciona directamente
        al realizar una compra, como su nombre, dirección de correo electrónico
        y datos de pago. Los datos de pago son procesados de forma segura por
        nuestros proveedores de pago y no almacenamos información de tarjetas de
        crédito en nuestros servidores.
      </p>

      <h4 className="font-serif text-lg text-white mt-4" data-id="element-45">
        2. Uso de la Información
      </h4>
      <p data-id="element-46">
        Utilizamos su información personal para: procesar y entregar su compra,
        enviar confirmaciones y actualizaciones relacionadas con su pedido, y
        mejorar nuestros productos y servicios. No vendemos ni compartimos su
        información personal con terceros para fines de marketing.
      </p>

      <h4 className="font-serif text-lg text-white mt-4" data-id="element-47">
        3. Protección de Datos
      </h4>
      <p data-id="element-48">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger su información personal contra acceso no autorizado,
        alteración, divulgación o destrucción. Utilizamos cifrado SSL para todas
        las transmisiones de datos.
      </p>

      <h4 className="font-serif text-lg text-white mt-4" data-id="element-49">4. Cookies</h4>
      <p data-id="element-50">
        Nuestro sitio web puede utilizar cookies para mejorar su experiencia de
        navegación y analizar el tráfico del sitio. Puede configurar su
        navegador para rechazar cookies, aunque esto puede afectar la
        funcionalidad del sitio.
      </p>

      <h4 className="font-serif text-lg text-white mt-4" data-id="element-51">5. Sus Derechos</h4>
      <p data-id="element-52">
        Usted tiene derecho a acceder, rectificar o eliminar su información
        personal. Para ejercer estos derechos, puede contactarnos a través de
        los canales indicados en nuestro sitio web.
      </p>

      <h4 className="font-serif text-lg text-white mt-4" data-id="element-53">
        6. Cambios en esta Política
      </h4>
      <p data-id="element-54">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Los cambios serán publicados en esta página con la
        fecha de actualización correspondiente.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-gold font-semibold text-base" data-id="element-55">
        Última actualización: Enero 2024
      </p>

      <h4 className="font-serif text-lg text-white mt-4" data-id="element-56">
        1. Aceptación de los Términos
      </h4>
      <p data-id="element-57">
        Al acceder y utilizar este sitio web y adquirir nuestros productos
        digitales, usted acepta estar sujeto a estos términos y condiciones. Si
        no está de acuerdo con alguna parte de estos términos, no debe utilizar
        nuestro sitio web ni adquirir nuestros productos.
      </p>

      <h4 className="font-serif text-lg text-white mt-4" data-id="element-58">
        2. Producto Digital
      </h4>
      <p data-id="element-59">
        El "Protocolo SOS: Insomnio Chino" es un producto digital informativo en
        formato PDF. El contenido es de carácter educativo y no sustituye el
        consejo médico profesional. Consulte siempre a un profesional de la
        salud antes de iniciar cualquier nuevo régimen de bienestar.
      </p>

      <h4 className="font-serif text-lg text-white mt-4" data-id="element-60">
        3. Entrega del Producto
      </h4>
      <p data-id="element-61">
        Tras completar su compra, recibirá acceso inmediato al producto digital
        mediante descarga. Es su responsabilidad asegurarse de que su
        dispositivo sea compatible con archivos PDF.
      </p>

      <h4 className="font-serif text-lg text-white mt-4" data-id="element-62">
        4. Propiedad Intelectual
      </h4>
      <p data-id="element-63">
        Todo el contenido del producto, incluyendo textos, gráficos, imágenes y
        diseño, está protegido por derechos de autor. Queda prohibida la
        reproducción, distribución o reventa del material sin autorización
        expresa por escrito.
      </p>

      <h4 className="font-serif text-lg text-white mt-4" data-id="element-64">
        5. Política de Reembolso
      </h4>
      <p data-id="element-65">
        Debido a la naturaleza digital del producto y su entrega inmediata, no
        se ofrecen reembolsos una vez completada la descarga. Si experimenta
        problemas técnicos con la descarga, contáctenos y le asistiremos.
      </p>

      <h4 className="font-serif text-lg text-white mt-4" data-id="element-66">
        6. Limitación de Responsabilidad
      </h4>
      <p data-id="element-67">
        Los resultados pueden variar de persona a persona. No garantizamos
        resultados específicos. El contenido se proporciona "tal cual" y no nos
        hacemos responsables de cualquier daño directo o indirecto derivado del
        uso del producto.
      </p>

      <h4 className="font-serif text-lg text-white mt-4" data-id="element-68">7. Ley Aplicable</h4>
      <p data-id="element-69">
        Estos términos se rigen por las leyes aplicables en la jurisdicción
        correspondiente. Cualquier disputa será resuelta en los tribunales
        competentes de dicha jurisdicción.
      </p>
    </>;
}